import { render } from "./PurchaseRequisition.vue?vue&type=template&id=29ab6b08&scoped=true"
import script from "./PurchaseRequisition.vue?vue&type=script&lang=js"
export * from "./PurchaseRequisition.vue?vue&type=script&lang=js"

import "./PurchaseRequisition.vue?vue&type=style&index=0&id=29ab6b08&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29ab6b08"]])

export default __exports__